import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {CoordinatorEQueryEscalations} from '../../models/e-query-details/coordinator-e-query-escalations';

@Component({
    selector: 'coordinator-e-query-email-escalations',
    template: require('./coordinator-e-query-email-escalations.component.html'),
    styles: [require('./coordinator-e-query-email-escalations.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CoordinatorEQueryEmailEscalationsComponent {
    @Input()
    public escalations: CoordinatorEQueryEscalations;

    public get hasFirstLevelEscalations(): boolean {
        if (!this.escalations) { return false; }
        return this.escalations.firstLevelEmailEscalations.length > 0;
    }

    public get hasSecondLevelEscalations(): boolean {
        if (!this.escalations) { return false; }
        return this.escalations.secondLevelEmailEscalations.length > 0;
    }

    public get hasThirdLevelEscalations(): boolean {
        if (!this.escalations) { return false; }
        return this.escalations.thirdLevelEmailEscalations.length > 0;
    }
}